import FetchUtils from 'src/utils/fetch_utils';
import LayoutUtils from 'src/utils/layout_utils';

/**
 * Init credit card editor: Stripe token or use existing, submit, toggle open/cancel.
 */
export function initCreditCardEditor(cardWrap) {
  if (cardWrap.dataset.bound === 'true') {
    return;
  }

  const saveUrl = cardWrap.dataset.saveUrl;
  const questionId = cardWrap.dataset.questionId;
  const fullNameInput = cardWrap.querySelector('.js-showing-view-cc-full-name');
  const addressInput = cardWrap.querySelector('.js-showing-view-cc-address');
  const tokenInput = cardWrap.querySelector('.js-showing-view-cc-token');
  const saveButton = cardWrap.querySelector('.js-showing-view-cc-save');
  const useExistingButton = cardWrap.querySelector('.js-showing-view-cc-use-existing');
  const toggleOpenButton = cardWrap.querySelector('.js-showing-view-cc-toggle-open');
  const toggleCancelButton = cardWrap.querySelector('.js-showing-view-cc-toggle-cancel');
  const cardBody = cardWrap.querySelector('.js-showing-view-cc-body');
  const errorsWrap = cardWrap.querySelector('.js-showing-view-cc-errors');
  const messageWrap = cardWrap.querySelector('.js-showing-view-credit-card-message');
  const stripeWrapper = cardWrap.querySelector('.js-stripe-card-form');

  if (!saveUrl || !questionId || !saveButton || !fullNameInput || !addressInput || !tokenInput) {
    return;
  }

  const showError = (text) => {
    if (!errorsWrap) return;
    errorsWrap.textContent = text || '';
  };

  const updateMessage = (text) => {
    if (messageWrap) {
      messageWrap.textContent = text;
    }
  };

  const submit = (params) => {
    showError('');
    const body = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      body.set(key, value);
    });

    return fetch(saveUrl, {
      method: 'PUT',
      headers: {
        'x-csrf-token': FetchUtils.CSRFToken(),
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        accept: 'application/json'
      },
      body: body.toString()
    })
      .then((resp) => FetchUtils.checkResponseStatus(resp))
      .then((resp) => resp.json())
      .then((response) => {
        if (!response.success) {
          throw { payload: response };
        }
        tokenInput.value = '';
        updateMessage(response.text || 'Credit Card Previously Approved');
      })
      .catch((err) => {
        const errMsg = err?.payload?.errors?.[0] || 'Unable to save credit card.';
        showError(errMsg);
        FetchUtils.handleResponseError(err);
      });
  };

  const createTokenIfNeeded = () => {
    if (tokenInput.value) {
      return Promise.resolve(tokenInput.value);
    }
    if (!stripeWrapper?._stripe || !stripeWrapper?._card || stripeWrapper.dataset.active === 'false') {
      return Promise.reject({ payload: { errors: ['Please enter credit card details.'] } });
    }
    return stripeWrapper._stripe.createToken(stripeWrapper._card).then((result) => {
      if (result.error) {
        throw { payload: { errors: [result.error.message] } };
      }
      tokenInput.value = result.token.id;
      return result.token.id;
    });
  };

  toggleOpenButton?.addEventListener('click', () => {
    LayoutUtils.show(cardBody);
    LayoutUtils.hide(toggleOpenButton);
    LayoutUtils.show(toggleCancelButton);
  });

  toggleCancelButton?.addEventListener('click', () => {
    LayoutUtils.hide(cardBody);
    LayoutUtils.hide(toggleCancelButton);
    LayoutUtils.show(toggleOpenButton);
    showError('');
  });

  saveButton.addEventListener('click', () => {
    saveButton.disabled = true;
    createTokenIfNeeded()
      .then((token) =>
        submit({
          question_id: questionId,
          full_name: fullNameInput.value,
          street_address: addressInput.value,
          stripe_token: token,
          use_existing: '0'
        })
      )
      .finally(() => {
        saveButton.disabled = false;
      });
  });

  useExistingButton?.addEventListener('click', () => {
    useExistingButton.disabled = true;
    submit({
      question_id: questionId,
      full_name: fullNameInput.value,
      street_address: addressInput.value,
      stripe_token: '',
      use_existing: '1'
    }).finally(() => {
      useExistingButton.disabled = false;
    });
  });

  cardWrap.dataset.bound = 'true';
}
